export class PublicacaoManual{

    DataImportacao: Date;
    GeradoMovimentacao: boolean;
    DataGeracaoMovimentacao: Date;
    UsuarioId: number;
    Advogado: string;
    OABNumero: string;
    OABEstado: string;
    Diario: string;
    EdicaoDiario: string;
    PaginaInicial: string;
    DataPublicacao: Date;
    NProcesso: string;
    CidadePublicacao: string;
    Orgao: string;
    Vara: string;
    DespachoPublicacao: string;
    ProcessoPublicacao: string ;
    AreaId: number;
    ProcessoId: number;
}
